import { render, staticRenderFns } from "./BuildingInvoiceTable.vue?vue&type=template&id=61f68abc&scoped=true&"
import script from "./BuildingInvoiceTable.vue?vue&type=script&lang=js&"
export * from "./BuildingInvoiceTable.vue?vue&type=script&lang=js&"
import style0 from "./BuildingInvoiceTable.vue?vue&type=style&index=0&id=61f68abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f68abc",
  null
  
)

export default component.exports